import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part2',
  templateUrl: './part2.component.html',
  styleUrls: ['./part2.component.scss']
})
export class Part2Component implements OnInit {

  readonly baseURL = './assets/images/part2/';

  constructor() { }

  ngOnInit(): void {
  }

}
